import type {EventDateInformation, PageDates} from '@wix/wix-events-commons-statics'
import React, {PropsWithChildren} from 'react'

interface IDatesContext {
  getEventDateInformation: (id: string) => EventDateInformation
  getCommonDateInformation: (id: string) => string
}

const DatesContext = React.createContext<IDatesContext>(null)

interface DatesProviderProps {
  dates: PageDates
}

export const DatesProvider = ({children, dates}: PropsWithChildren<DatesProviderProps>) => {
  const getEventDateInformation = (id: string): EventDateInformation => dates.events[id]

  const getCommonDateInformation = (id: string): string => dates.common[id]

  return (
    <DatesContext.Provider value={{getEventDateInformation, getCommonDateInformation}}>
      {children}
    </DatesContext.Provider>
  )
}

export const useEventDateInformation = (id: string) => {
  return React.useContext<IDatesContext>(DatesContext).getEventDateInformation(id)
}

export const useCommonDateInformation = (id: string) => {
  return React.useContext<IDatesContext>(DatesContext).getCommonDateInformation(id)
}
